/** localStorage key for a referral code captured from /referral/[code] before login. */
export const PENDING_REFERRAL_STORAGE_KEY = 'xox_pending_referral_code';

const CODE_PATTERN = /^[A-Za-z0-9_-]{2,30}$/;

export function isValidReferralCodeFormat(code: string): boolean {
  return CODE_PATTERN.test(code.trim());
}

export function setPendingReferralCode(code: string): void {
  if (typeof window === 'undefined') return;
  const t = code.trim();
  if (!isValidReferralCodeFormat(t)) return;
  try {
    localStorage.setItem(PENDING_REFERRAL_STORAGE_KEY, t);
  } catch {
    /* quota / private mode */
  }
}

export function getPendingReferralCode(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = localStorage.getItem(PENDING_REFERRAL_STORAGE_KEY);
    if (!v) return null;
    const t = v.trim();
    return isValidReferralCodeFormat(t) ? t : null;
  } catch {
    return null;
  }
}

export function clearPendingReferralCode(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(PENDING_REFERRAL_STORAGE_KEY);
  } catch {
    /* noop */
  }
}
